var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Dodaj produkt do magazynu")]),_c('ItemForm',{attrs:{"types":_vm.types},on:{"submited":function($event){return _vm.add($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }